const anchors = document.querySelectorAll('a[href*="#"]');

for (let anchor of anchors) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const blockID = anchor.getAttribute('href').substr(1)

        document.getElementById(blockID).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
}

$(document).ready(function (){
    $('#contact-form').validate({
        submitHandler: function(form) {
            $('#contact-form').ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.success').fadeIn();
                        setTimeout(function (){
                            $('.success').fadeOut();
                        }, 8000);
                    } else {
                        $('.error').fadeIn();
                        setTimeout(function (){
                            $('.success').fadeOut();
                        }, 8000);
                    }
                }
            });
        }
    });

    $('.purchase-modal .btn-success').on('click', function () {
        $('#purchase-form').submit();
    });

    $('#purchase-form').validate({
        submitHandler: function (form) {
            $('.purchase-modal .loading').fadeIn().css('display', 'flex');
            $('.purchase-modal .btn-success').attr('disabled', 'disabled');
            $('#purchase-form').ajaxSubmit({
               clearForm: true,
               success: function (data) {
                   if (data == 'success') {
                       $('.purchase-modal .loading').html('<div class="text-center px-4"><strong>This is a confirmation of receiving your order. An invoice has been sent to your email, in order to complete your order please proceed with a payment.</strong></div>').css('background-color', 'rgba(255,255,255,0.9)');
                   } else {
                       $('.purchase-modal .loading').html('<div class="text-center px-4"><strong>Your order has not been created.<br> Please try again to create your order.</strong></div>').css('background-color', 'rgba(255,255,255,0.9)');
                   }
               }
            });
        }
    });

    $('.purchase-modal').on('hidden.bs.modal', function (event) {
        $('.purchase-modal .loading').fadeOut();
        $('#purchase-form select').prop('selectedIndex', 0);
        $('.purchase-modal .btn-success').removeAttr('disabled');
    });
});